import { storageImage, storageSrcSet } from "@/lib/imageUrl";
import { useQuery } from "@tanstack/react-query";
import { clientLogosQuery, LOAD_ERROR_MESSAGE } from "@/lib/publicQueries";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const ClientLogos = () => {
  const anim = useScrollAnimation();
  const { data: logos = [], isLoading: loading, isError } = useQuery(clientLogosQuery());

  // Don't render if no logos after loading
  if (!loading && !isError && logos.length === 0) {
    return null;
  }

  return (
    <section className="py-12 md:py-16 bg-muted/20">
      <div
        ref={anim.ref}
        className={`container-custom transition-all duration-1000 ${
          anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Unsere Kunden
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Unternehmen, für die wir fotografiert und gefilmt haben
          </p>
        </div>

        {isError && logos.length === 0 && (
          <p role="alert" className="text-center text-muted-foreground">{LOAD_ERROR_MESSAGE}</p>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          {logos.map((logo) => (
            <div key={logo.id} className="relative group">
              <div className="absolute inset-0 bg-primary/5 rounded-lg blur-md opacity-50" />
              <div className="relative flex items-center justify-center p-6 h-32 bg-card border border-border rounded-lg hover:border-primary/50 transition-colors">
                <img
                  src={storageImage(logo.logo_url, 320)}
                  alt={`Logo ${logo.company_name || "Kunde"}`}
                  className="w-full h-auto max-h-16 object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
